module.exports = __webpack_public_path__ + "img/user@2x.78700161.svg";